import { saveItemSession } from "utils/session";
import { formatDate } from "utils/utils";
import { InsightsStrings, RefreshKey } from "constants/constantStrings";

export const getName = params => {
  if (params) {
    return params.data.AnomalyType === InsightsStrings.FIT1 ? InsightsStrings.feedFlow : InsightsStrings.brineFlow;
  }
};

export const getCell = (params, field) =>
  field === "description"
    ? params?.data.AnomalyType === InsightsStrings.FIT1
      ? InsightsStrings.feedInsight
      : InsightsStrings.brineInsight
    : InsightsStrings.recommendationDescription;

export const formatTime = (params, duration) => {
  if (params) {
    return formatDate(params.data[duration]);
  }
};

export const focusDefaultTabInAlarms = () => saveItemSession(RefreshKey.alarmTabKey, 0);

export const focusDefaultTabInInsights = () => saveItemSession(RefreshKey.insightTabKey, 0);
